import styles from "./empty.module.scss";

interface Props {
  type: string;
}

const Empty = ({ type }: Props) => {
  return (
    <div className={styles.empty}>
      <p className={styles.empty__title}>{type} пока не загрузили 😞</p>
      <p className={styles.empty__description}>
        Но уже в самое ближайшее время обязательно загрузим
      </p>
    </div>
  );
};
export default Empty;
